import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { authAtom, userAtom, roleAtom } from '../../config/atoms';

import { SquareUser, FileText, LogOut, Gauge, Store, UserCircle } from 'lucide-react';

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import icLogo from '../../../assets/image/logo-icon.png';

export default function NavigationBar() {

    const { page } = useParams();

    const [authStatus, setAuthStatus] = useRecoilState(authAtom);
    const [roles, setUserRole] = useRecoilState(roleAtom);
    const [, setUserData] = useRecoilState(userAtom);

    const navigate = useNavigate();

    const changeMainMenu = (link) => {
        navigate(`/${link}`);
    }

    const logout = () => {
        setAuthStatus(false);
        setUserData({});
        setUserRole({});
        localStorage.clear();
        sessionStorage.clear();
        navigate('/');
    }

    const getOrg = () => {
        if (page === "orgInfo" || page === "outlet" || page === "outletInfo") {
            return true;
        }
        return false;
    }

    const getReport = () => {
        if (page === "reports" || page === "trns" || page === "task") {
            return true;
        }
        return false;
    }

    return (
        <>
            {!authStatus && <Navigate to="/" />}
            <div className="h-screen shadow-md bg-prime hidden xs:block w-16">
                <span className="cursor-pointer bg-gray-900 my-1" onClick={() => { changeMainMenu('home') }}>
                    <div className="w-16 h-16 bg-gray-900">
                        <img src={icLogo} className="w-12 m-auto py-2" />
                    </div>
                </span>
                <div className='w-3/5 h-[2px] bg-white rounded-full mx-[20%]'></div>
                <ul className="flex flex-col items-center h-[90%]">
                    <Tippy content="Overview Section" placement='right'>
                        <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "home" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('home') }}>
                            <Gauge size={20} />
                        </li>
                    </Tippy>
                    {
                        roles.role !== "PARTNER" && <Tippy content="Restaurants Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getOrg() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('outlet') }}>
                                <Store size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        roles.role !== "PARTNER" && < Tippy content="Reports Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${getReport() ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('reports') }}>
                                <FileText size={20} />
                            </li>
                        </Tippy>
                    }
                    {
                        roles.role !== "PARTNER" && <Tippy content="Staffs Section" placement='right'>
                            <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "staff" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('staff') }}>
                                <SquareUser size={20} />
                            </li>
                        </Tippy>
                    }
                    <div className='flex-grow'></div>
                    <Tippy content="Profile" placement='right'>
                        <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white hover:text-ascent ${page === "profile" ? "bg-white text-ascent" : "text-white"}`} onClick={() => { changeMainMenu('profile') }}>
                            <UserCircle size={20} />
                        </li>
                    </Tippy>
                    <Tippy content="Logout" placement='right'>
                        <li className={`cursor-pointer w-12 h-12 my-1 flex items-center justify-center rounded-full hover:rounded-2xl hover:bg-white text-white hover:text-ascent`} onClick={() => { logout() }}>
                            <LogOut size={20} />
                        </li>
                    </Tippy>
                </ul>
                <p className='text-sm text-center text-white'>v2.0.0a</p>
            </div >
            <div className="fixed bottom-0 bg-white h-12 w-full rounded-t-md px-2 xs:hidden"></div>
        </>
    )
}
